var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12655 4.49365C4.39017 4.49365 3.79321 5.09061 3.79321 5.82699V8.29628H22.4689V5.82699C22.4689 5.09061 21.8719 4.49365 21.1355 4.49365H5.12655ZM22.1916 10.9629H4.07051C4.20546 11.2353 4.38727 11.4852 4.61063 11.7002L11.2818 18.1212C12.3143 19.115 13.9477 19.115 14.9803 18.1212L21.6514 11.7002C21.8748 11.4852 22.0566 11.2353 22.1916 10.9629Z",
    fill: "#0096FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7979 23.2004L15.7979 14.7656H10.4646V25.7683L15.7979 23.2004Z",
    fill: "#0096FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0d1420cc987a1df3d4dea5ad99a6226a.svg";
export { ForwardRef as ReactComponent };